// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/entry.client.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
var _s = $RefreshSig$();
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/entry.client.tsx");
  import.meta.hot.lastModified = "1744085769114.8093";
}
// REMIX HMR END

import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import { RemixBrowser } from '@remix-run/react';
import { CacheProvider } from '@emotion/react';
import CssBaseline from '@mui/material/CssBaseline';
import ClientStyleContext from './src/ClientStyleContext';
import createEmotionCache from './src/createEmotionCache';
import { ThemeToggleProvider } from './src/ThemeContext';
function ClientCacheProvider({
  children
}) {
  _s();
  const [cache, setCache] = React.useState(createEmotionCache());
  const clientStyleContextValue = React.useMemo(() => ({
    reset() {
      setCache(createEmotionCache());
    }
  }), []);
  return <ClientStyleContext.Provider value={clientStyleContextValue}>
      <CacheProvider value={cache}>{children}</CacheProvider>
    </ClientStyleContext.Provider>;
}
_s(ClientCacheProvider, "SCB+MKDmvJaXD2ZKWjt8CMfkuGc=");
_c = ClientCacheProvider;
const hydrate = () => {
  React.startTransition(() => {
    ReactDOM.hydrateRoot(document, <ClientCacheProvider>
        <ThemeToggleProvider>
          <CssBaseline />
          <RemixBrowser />
        </ThemeToggleProvider>
      </ClientCacheProvider>);
  });
};
if (window.requestIdleCallback) {
  window.requestIdleCallback(hydrate);
} else {
  // Safari doesn't support requestIdleCallback
  // https://caniuse.com/requestidlecallback
  setTimeout(hydrate, 1);
}
var _c;
$RefreshReg$(_c, "ClientCacheProvider");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;